module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar"
  }, [_c('counters-block'), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return [(link.page && link.page !== _vm.$route.name) ? _c('router-link', {
      attrs: {
        "to": {
          name: link.page
        }
      }
    }, [_vm._v("\n      " + _vm._s(link.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (link.link) ? _c('a', {
      attrs: {
        "href": link.link
      }
    }, [_vm._v("\n      " + _vm._s(link.title) + "\n    ")]) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e5e0ea6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = 1010
// module chunks = 1